/**
 * @generated SignedSource<<748218e785a24e4a786c144b2485a5b1>>
 * @relayHash e23a392859b2b51fddbeeda10222c5f1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4f75c83f606a3e5ff7c1689b48da52aeef2fb5befb8ac308207413d57d40969e

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { HorizontalNavJiraInnerQuery } from './HorizontalNavJiraInnerQuery.graphql';

import isJiraCustomTemplatesUxEnabled_provider from '@atlassian/jira-relay-provider/src/jira-custom-templates-ux-fg.relayprovider';
import showInviteButton_provider from '@atlassian/jira-relay-provider/src/jira-invite-button.relayprovider';

const node: PreloadableConcreteRequest<HorizontalNavJiraInnerQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "4f75c83f606a3e5ff7c1689b48da52aeef2fb5befb8ac308207413d57d40969e",
    "metadata": {},
    "name": "HorizontalNavJiraInnerQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider": isJiraCustomTemplatesUxEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjirainvitebuttonrelayprovider": showInviteButton_provider
    }
  }
};

export default node;
